import ManagementSolutions from '../../pages/managementSolutions/managementSolutions';

export default class Search {
    constructor() {
        this.searchResultPagesPosts = document.querySelector('.searchResult__pagesPosts');
        this.searchResultProducts = document.querySelector('.searchResult__products');
        this.searchResultSolutions = document.querySelector('.searchResult__solutions');

        this.buttonDisplayPagesPosts = document.getElementById('search_displayPagesPosts');
        this.buttonDisplayProducts = document.getElementById('search_displayProducts');
        this.buttonDisplaySolutions = document.getElementById('search_displaySolutions');

        this.bindEvents();

        this.initSolutions();
    }

    bindEvents() {
        this.buttonDisplayPagesPosts.addEventListener('click', () => this.displayPagesPosts());
        this.buttonDisplayProducts.addEventListener('click', () => this.displayProducts());
        this.buttonDisplaySolutions.addEventListener('click', () => this.displaySolutions());
    }

    displayPagesPosts() {
        this.buttonDisplayPagesPosts.classList.remove('inactive');
        this.buttonDisplayProducts.classList.add('inactive');
        this.buttonDisplaySolutions.classList.add('inactive');
        this.searchResultPagesPosts.classList.add('isActive');
        this.searchResultProducts.classList.remove('isActive');
        this.searchResultSolutions.classList.remove('isActive');
    }

    displayProducts() {
        this.buttonDisplayPagesPosts.classList.add('inactive');
        this.buttonDisplayProducts.classList.remove('inactive');
        this.buttonDisplaySolutions.classList.add('inactive');
        this.searchResultPagesPosts.classList.remove('isActive');
        this.searchResultProducts.classList.add('isActive');
        this.searchResultSolutions.classList.remove('isActive');
    }

    displaySolutions() {
        this.buttonDisplayPagesPosts.classList.add('inactive');
        this.buttonDisplayProducts.classList.add('inactive');
        this.buttonDisplaySolutions.classList.remove('inactive');
        this.searchResultPagesPosts.classList.remove('isActive');
        this.searchResultProducts.classList.remove('isActive');
        this.searchResultSolutions.classList.add('isActive');
    }

    initSolutions() {
        if (
            !window.managementSolutionItems ||
            window.managementSolutionItems.length < 1
        ) {
            return;
        }

        const items = window.managementSolutionItems;

        ManagementSolutions.setItems(items);

        let html = '';

        for (let i = 0; i < items.length; i++) {
            html += ManagementSolutions.getHtmlForItem(items[i], i);
        }

        document.querySelector('.searchResult__solutions').innerHTML = html;

        ManagementSolutions.showAllItems();
    }
}



// WEBPACK FOOTER //
// ./src/pages/search/search.js